import { SubscriberType } from './interfaces/SubscriberType';

export const isEligibleSubscriberType = (
	subscriberType: SubscriberType,
	allowedApplicationType: SubscriberType,
) => {
	switch (allowedApplicationType) {
		case SubscriberType.Account:
			return subscriberType === SubscriberType.Account;

		case SubscriberType.SystemEntity:
			return subscriberType === SubscriberType.SystemEntity;

		case SubscriberType.AccountOrSystemEntity:
			return (
				subscriberType === SubscriberType.Account ||
				subscriberType === SubscriberType.SystemEntity
			);

		default:
			return false;
	}
};
